import { Pipe, PipeTransform } from '@angular/core';

import { NO_VALUE } from '@pipes';

import { SupportedCountry } from '../../models/supportedCountry.model';

@Pipe({
  name: 'region',
  standalone: true,
})
export class RegionPipe implements PipeTransform {
  transform(region: string, supportedCountries: SupportedCountry[]): string {
    if (!region) {
      return;
    }

    const regionDataArray = region.split('-');
    let countryCode;
    let regionCode;

    regionDataArray.forEach((regionData, index) => {
      if (index === 0) {
        countryCode = regionData;
      }
      if (index === 1) {
        regionCode = regionData;
      }
      if (index > 1) {
        regionCode += `-${regionData}`;
      }
    });

    const country = supportedCountries.find(
      (supportedCountry) => supportedCountry.countryCode.toLowerCase() === countryCode.toLowerCase()
    );

    const regionValue = country?.regions.find((r) => r.shortCode === regionCode);
    if (regionValue) {
      return regionValue.name;
    } else if (regionCode) {
      return regionCode;
    } else {
      return NO_VALUE;
    }
  }
}
